// AdvancedParams.js
import React from 'react';
import PropTypes from 'prop-types';
import styles from './TraderDashboard.module.css';

const AdvancedParams = ({ params, onInputChange }) => (
  <div className={`${styles.gridContainer} ${styles.advancedGridContainer}`}>
    <label className={styles.fieldLabel}>Lookback Period</label>
    <label className={styles.fieldLabel}>Threshold (%)</label>
    <input
      type="number"
      name="lookback_period"
      value={params.lookback_period || 20}
      onChange={onInputChange}
      className={`${styles.formInput} ${styles.gridInput}`}
      min="1"
      max="365"
    />
    <input
      type="number"
      name="threshold"
      value={params.threshold || 0.05}
      onChange={onInputChange}
      className={`${styles.formInput} ${styles.gridInput}`}
      step="0.01"
      min="0"
      max="1"
    />
  </div>
);

AdvancedParams.propTypes = {
  params: PropTypes.shape({
    lookback_period: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    threshold: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  onInputChange: PropTypes.func.isRequired,
};

export default AdvancedParams;